export default "__VITE_ASSET__d6344c50__"